export default __webpack_public_path__ + "static/media/SM.551aef16.svg";